export default "__VITE_ASSET__BRIkxzlo__"